import version from '@/version';

export const getBuildVersion = () => {
  return version.buildNumber.toString();
};
